// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"63":"c8b9ca47","256":"179c1a71","261":"a04baacb","380":"fe1a1a22","641":"52d3602a","886":"18af5921","923":"e222b6ed"}[chunkId] + ".chunk.css";
};